<template>
<g>
<g v-show="valor === 0">
<g id="ancho3">
	<path class="st8" d="M104.2,451.9l-6,18h-7.7l19.5-57.3h8.9l19.6,57.3h-7.9l-6.1-18H104.2z M123,446.2l-5.6-16.5
		c-1.3-3.7-2.1-7.1-3-10.5h-0.2c-0.9,3.4-1.8,6.9-2.9,10.4l-5.6,16.6H123z"/>
	<path class="st8" d="M146.5,440c0-4.3-0.1-7.7-0.3-11.1h6.6l0.4,6.8h0.2c2-3.9,6.8-7.7,13.6-7.7c5.7,0,14.5,3.4,14.5,17.5V470H174
		v-23.7c0-6.6-2.5-12.2-9.5-12.2c-4.9,0-8.8,3.5-10,7.7c-0.3,0.9-0.5,2.2-0.5,3.5V470h-7.5V440z"/>
	<path class="st8" d="M223,468.4c-2,1-6.3,2.4-11.8,2.4c-12.4,0-20.5-8.4-20.5-21c0-12.7,8.7-21.8,22.1-21.8c4.4,0,8.3,1.1,10.4,2.1
		l-1.7,5.8c-1.8-1-4.6-2-8.7-2c-9.4,0-14.5,7-14.5,15.6c0,9.5,6.1,15.4,14.3,15.4c4.3,0,7.1-1.1,9.2-2L223,468.4z"/>
	<path class="st8" d="M231.7,409.6h7.5v25.7h0.2c1.2-2.1,3.1-4,5.4-5.3c2.2-1.3,4.8-2.1,7.7-2.1c5.5,0,14.4,3.4,14.4,17.6V470h-7.5
		v-23.6c0-6.6-2.5-12.2-9.5-12.2c-4.8,0-8.7,3.4-10,7.5c-0.4,1-0.5,2.1-0.5,3.6V470h-7.5V409.6z"/>
	<path class="st8" d="M316.1,449c0,15.2-10.5,21.8-20.5,21.8c-11.1,0-19.7-8.2-19.7-21.2c0-13.8,9-21.8,20.4-21.8
		C308.1,427.9,316.1,436.5,316.1,449z M283.5,449.5c0,9,5.2,15.8,12.5,15.8c7.1,0,12.5-6.7,12.5-16c0-7-3.5-15.8-12.3-15.8
		S283.5,441.7,283.5,449.5z"/>
</g>
</g>
<g v-show="valor === 1">
<g xmlns="http://www.w3.org/2000/svg" style="">
	<path class="st5" d="M142.1,407.5c6.9,0,12.1,2.8,15.8,8.3c3.6,5.5,5.4,13.6,5.4,24.1c0,10.5-1.8,18.6-5.4,24.1   c-3.6,5.6-8.9,8.3-15.8,8.3c-6.9,0-12.2-2.8-15.8-8.3c-3.6-5.5-5.4-13.6-5.4-24.1c0-10.5,1.8-18.5,5.4-24.1   C130,410.2,135.2,407.5,142.1,407.5z M142.1,414.1c-4.1,0-7.2,2.2-9.3,6.5c-2.1,4.4-3.2,10.8-3.2,19.2c0,8.3,1.1,14.7,3.2,19.1   c2.1,4.4,5.2,6.6,9.3,6.6c4,0,7-2.2,9.1-6.5s3.2-10.7,3.2-18.9c0-8.5-1-14.9-3.1-19.3C149.3,416.3,146.2,414.1,142.1,414.1z" style=""/>
	<path class="st5" d="M177.9,461.6h9.1l-7.4,20.7h-7.3L177.9,461.6z"/>
	<path class="st5" d="M223.5,408.6H234v41.6h9.1v6.9H234v14h-8.2v-14h-29.6v-8L223.5,408.6z M226,416.3l-22.6,33.9h22.4L226,416.3z"/>
	<path class="st5" d="M254.4,408.6h34.4v6.6h-26.3l-0.4,17.3c1.5-0.3,3-0.5,4.4-0.7c1.4-0.1,2.7-0.2,4.1-0.2   c6.4,0,11.5,1.7,15.2,5.1s5.6,8.1,5.6,13.9c0,6.5-2.2,11.6-6.7,15.4s-10.5,5.7-18.1,5.7c-2.2,0-4.4-0.2-6.6-0.6s-4.5-1-6.7-1.8   l-0.1-8.1c1.9,1.1,4,1.9,6.2,2.5s4.7,0.9,7.3,0.9c4.8,0,8.7-1.3,11.6-3.8s4.3-5.8,4.3-10c0-3.8-1.4-6.9-4.1-9.1s-6.4-3.4-11-3.4   c-1.8,0-3.8,0.2-6.1,0.5c-2.3,0.3-4.8,0.8-7.4,1.5L254.4,408.6z"/>
</g>
</g>
<g v-show="valor === 2">
<g xmlns="http://www.w3.org/2000/svg" id="_x32_nn_3_">
	<path class="st7" d="M112.6,462.4h28.6v7.1h-39v-7.3c11.3-11.2,18.8-19.5,22.7-24.9c3.9-5.4,5.8-10.1,5.8-13.9   c0-2.9-1.1-5.3-3.2-7.1s-4.9-2.8-8.4-2.8c-2.3,0-4.7,0.4-7.1,1.1c-2.4,0.8-4.7,1.9-6.9,3.4l-1-8c2.9-1.3,5.8-2.3,8.7-3   c2.9-0.7,5.8-1,8.7-1c5.2,0,9.5,1.6,12.8,4.7c3.3,3.1,4.9,7.2,4.9,12.2c0,4.8-1.9,10.1-5.8,15.9   C129.6,444.8,122.6,452.6,112.6,462.4z" style=""/>
	<path class="st7" d="M191.9,433.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2c-1.4-2.1-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23H156v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C189,427.5,190.7,430,191.9,433.2z"/>
	<path class="st7" d="M271.5,433.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2s-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C268.6,427.5,270.3,430,271.5,433.2z"/>
</g>
</g>
</g>
</template>

<script>

export default {
  name: 'canto3',
  props: { valor: Number },
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Canto3.vue